import type {ThemeId} from "@project/design-system-core";

/**
 * Applies a theme by setting the appropriate class and data-theme attribute
 * on the <html> element. This is a plain DOM utility — no React required.
 *
 * HeroUI activates its built-in themes via these attributes:
 *   class="light"  data-theme="light"
 *   class="dark"   data-theme="dark"
 *
 * Custom themes only need data-theme (no class needed unless using Tailwind
 * dark-mode class strategy alongside them).
 */
export function applyTheme(id: ThemeId): void {
  const root = document.documentElement;

  root.classList.remove("light", "dark");
  root.classList.add(id);
  root.setAttribute("data-theme", id);
}
